import React, { Component, Fragment } from 'react';
import { string, array } from 'prop-types';
import classnames from 'classnames/bind';

import { Consumer } from './FormField';
import Input from './Input';
import CreditCardList from 'common/CreditCardList/CreditCardList';
import WithValidation from './WithValidation';
import InputLabel from 'elements/Inputs/InputLabel';

import styles from './CCInput.css';

const cx = classnames.bind(styles);

export default class CCInput extends Component {
  static propTypes = {
    placeholder: string,
    type: string,
    customClasses: string,
    validations: array,
    label: string,
  };

  static defaultProps = {
    placeholder: 'Enter number',
    type: 'number',
    customClasses: ''
  };

  state = { value: '' };

  handleChange = e => {

    const { value } = e.currentTarget;

    // Credit card number must have less than 16 characters
    if (value.length > 16) {
      return false;
    }

    this.setState({ value });
  }

  render() {
    const { placeholder, type, customClasses, validations, label } = this.props;
    const { value } = this.state;
    const wrapperClasses = cx({ isFilled: value.length }, 'full-width');

    return (
      <div className={wrapperClasses}>
        <Consumer>
          {sharedProps =>
            <WithValidation
              value={value}
              validations={validations}
              render={
                error => (
                  <Fragment>
                    <InputLabel {...sharedProps} label={label} />
                    <div className="relative">
                      <Input
                        sharedProps={sharedProps}
                        customClasses={`${customClasses} ${styles.ccInput}`}
                        placeholder={placeholder}
                        onChange={this.handleChange}
                        value={value}
                        error={error}
                        type={type}
                      />
                      <CreditCardList value={value} />
                    </div>

                  </Fragment>
                )
              }
            />
          }
        </Consumer>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/uis/elements/Inputs/CCInput.js